<script>
  import { cx } from "$lib/utils/cx";
  export let fixedWidth = false;
</script>

<div
  aria-label="Pane"
  class={cx(
    "max-h-full pt-5 bg-surface border border-line-strong rounded-xl text-xs overflow-auto",
    $$props.class,
  )}
  class:w-72={fixedWidth}
  class:flex-shrink-0={fixedWidth}
>
  <slot />
</div>
